// TODO
export function useShowAuthModal(): () => any {
  return () => {};
  // const appCtx = useAppContext()
  // return () => appCtx.setAuthModalVisibility(true)
}
